.gameIsOnHeader {
  padding: 16px;
  background: linear-gradient(135deg, var(--color-active-2), var(--color-active-3));
  color: black;
  font-size: 20px;
}
